import styles from "./About.module.css";

const About = ({ data, onChange }) => {
  return (
    <>
      <div className={styles.content_wrap}>
        <div className={styles.content}>
          <div className={styles.title}>About</div>
          <div className={styles.description}>{data.about}</div>
        </div>
      </div>
    </>
  );
};

export default About;
